import axios from "../plugins/parseAxios";
export class AppealAPI {
  constructor(props) { }
  static getAppeals(payload) {
    return axios.post("functions/getAppeals", {
      projectId: payload.projectId,
    });
  }
  static getAppeal(payload) {
    return axios.post("functions/getAppeal", {
      id: payload.id,
    });
  }
  static createAppeal(payload) {
    return axios.post("functions/createAppeal", payload);
  }
  static updateAppeal(payload) {
    return axios.post("functions/updateAppeal", payload);
  }
  static changeStatusAppeal(payload) {
    return axios.post("functions/changeStatusAppeal", payload);
  }
  static getAppealsByMarket(payload) {
    return axios.post("functions/getAppealsByMarket", payload)
  }
  static getAppealsByProject(projectId, limit, page, order) {
    return axios.post("functions/getAppealsByProject", {
      projectId,
      limit,
      page,
      order,
    });
  }
  static checkWaitingStatus(payload) {
    return axios.post("functions/checkWaitingStatus", {
      id: payload.id,
    });
  }
  static getAppealBetweenDateByMarket(formData) {
    return axios.post("functions/getAppealBetweenDateByMarket", formData);
  }
  

}
